// Thin helpers around native <dialog> elements addressed by id.

type CloseHandler = () => void;

const closeHandlers = new Map<Element, CloseHandler>();

export function showModal(id: string, onClose?: CloseHandler) {
  const el = document.querySelector<HTMLDialogElement>(`#${id}`);
  if (!el) {
    return;
  }

  el.showModal?.();

  if (onClose) {
    attachDialogEvents(el, onClose);
  }
}

export function hideModal(id: string) {
  const el = document.querySelector<HTMLDialogElement>(`#${id}`);
  if (!el) {
    return;
  }

  el.close?.();
  detachDialogEvents(el);
}

function attachDialogEvents(el: Element, onClose: CloseHandler) {
  detachDialogEvents(el);
  closeHandlers.set(el, onClose);
  el.addEventListener("close", onClose);
}

function detachDialogEvents(el: Element) {
  const existing = closeHandlers.get(el);
  if (existing) {
    el.removeEventListener("close", existing);
    closeHandlers.delete(el);
  }
}
